import { forwardRef, rem, StyleProps } from '@bonusly/design-system';

import { TagButton } from './tag-button';

export type AmountButtonProps = StyleProps;

export const AmountButton = forwardRef<AmountButtonProps, 'button'>((props, ref) => {
	return <TagButton tag="amount" p={{ base: rem(4), sm: 'auto' }} pr={{ base: rem(12), sm: 'auto' }} {...props} ref={ref} />;
});
